angular.module('gym.mobile_app').controller('MobileAppOptInCtrl', ["$scope", "$rootScope", "$state", "$window", "MobileApp", "GTMService", "planData", function($scope, $rootScope, $state, $window, MobileApp, GTMService, planData) {
  $scope.planData = planData;
  $scope.isFeatureEnabled = !!_.find($rootScope.gym.features_enabled, function(feature) {
    return feature === 'mobile_app';
  });
  GTMService.trackPage('Mobile App Toggle');
  return $scope.optIn = function() {
    GTMService.trackPage('Mobile App Toggle', 'Let\'s get started');
    return MobileApp.doPOST({}, 'settings/opt_in').then(function() {
      var url;
      url = $state.href('gym.mobile_app.settings');
      return $window.open(url, '_self');
    });
  };
}]);
